<template>
    <div>

        <h1>Venues</h1>
        <select v-model="selectedVenue" class="form-control my-2">
            <option value="null" disabled>Select an option</option>
            <option v-for="option in venues" :key="option.id" :value="option.id">
                {{ option.name }}
            </option>
        </select>
        <venues-table
            :list="venues"
            :selected="selectedVenue"
            @select="selectVenue"
            @edit="goEdit('venue', $event)"
            @remove="remove(venues, $event)"
        />
        <create-venue
            :item="venue"
            @item="venue = $event"
            @add="add(venues, $event)"
            @edit="edit(venues, $event)"
        />

        <h1 v-if="selectedVenue">
            Stages
            <small>for {{ getObjectByID(venues, selectedVenue).name }}</small>
        </h1>
        <stages-table
            v-show="selectedVenue"
            :selectedParent="selectedVenue"
            :list="stages"
            :selected="selectedStage"
            @select="selectStage"
            @edit="goEdit('stage', $event)"
            @remove="remove(stages, $event)"
        />
        <create-stage
            v-show="selectedVenue"
            :selectedParent="selectedVenue"
            :item="stage"
            @item="stage = $event"
            @add="add(stages, $event)"
            @edit="edit(stages, $event)"
        />

        <h1 v-if="selectedStage">
            Sections
            <small>for {{ getObjectByID(stages, selectedStage).name }}</small>
        </h1>
        <sections-table
            v-show="selectedStage"
            :selectedParent="selectedStage"
            :list="sections"
            :selected="selectedSection"
            @select="selectSection"
            @edit="goEdit('section', $event)"
            @remove="remove(sections, $event)"
        />
        <create-section
            v-show="selectedStage"
            :selectedParent="selectedStage"
            :item="section"
            @item="section = $event"
            @add="add(sections, $event)"
            @edit="edit(sections, $event)"
        />

        <h1 v-if="selectedSection">
            Seats
            <small>for Section {{ getObjectByID(sections, selectedSection).name }}</small>
        </h1>
        <seats-table
            v-show="selectedSection"
            :seats="seats"
        />
        <create-seat
            v-show="selectedSection"
            :section_id="selectedSection"
            :seats="seats"
            @seats="seats = $event"
        />
        
    </div>
</template>

<script>
import CreateVenue from './CreateVenue';
import CreateStage from './CreateStage';
import CreateSection from './CreateSection';
import CreateSeat from './CreateSeat';

import VenuesTable from './VenuesTable';
import VenueModal from './VenueModal';
import StagesTable from './StagesTable';
import SectionsTable from './SectionsTable';
import SeatsTable from './SeatsTable';
export default {
    props: {},

    data() {
        return {
            venues: [],
            selectedVenue: null,
            stages: [],
            selectedStage: null,
            sections: [],
            selectedSection: null,
            seats: [],
            selectedSeat: null,

            venue: {},
            stage: {},
            section: {},
            seat: {},
        };
    },

    created() {
        this.fetchVenues();
    },

    methods: {
        fetchVenues() {
            axios.get('/event/venues/all')
            .then(res => {
                this.venues = res.data;
            });
        },
        fetchStages(id) {
            var stageUrl = '/event/venues/' + id + '/stages';
            axios.get(stageUrl)
            .then(res => {
                this.stages = res.data;
            });
        },
        fetchSections(id) {
            var sectionUrl = '/event/stages/' + id + '/sections';
            axios.get(sectionUrl)
            .then(res => {
                this.sections = res.data;
            });
        },
        fetchSeats(id) {
            var seatsUrl = '/event/sections/' + id + '/seats';
            axios.get(seatsUrl)
            .then(res => {
                this.seats = res.data;
            });
        },
        getObject(array, key, value) {
            return array.find(obj => obj[key] == value);
        },
        getObjectByID(array, value) {
            return this.getObject(array, 'id', value);
        },
        getIndex(array, key, value) {
            return _.findKey(array, obj => obj[key] == value);
        },
        getIndexByID(array, value) {
            return this.getIndex(array, 'id', value);
        },
        selectVenue(id) {
            this.resetStages();
            this.selectedVenue = id;
        },
        selectStage(id) {
            this.resetSections();
            this.selectedStage = id;
        },
        selectSection(id) {
            this.resetSeats();
            this.selectedSection = id;
        },
        selectSeat(id) {
            this.selectedSeat = id;
        },
        resetStages() {
            this.resetSections();
            this.selectedStage = null;
            this.stages = [];
        },
        resetSections() {
            this.resetSeats();
            this.selectedSection = null;
            this.sections = [];
        },
        resetSeats() {
            this.selectedSeat = null;
            this.seats = [];
        },

        goEdit(itemName, editItem) {
            this[itemName] = Object.assign({}, editItem);
        },

        // UI Functions
        add(list, item) {
        	console.log('add place:'.item);
            list.push(item);
        },
        edit(list, item) {
            var index = this.getIndexByID(list, item.id);
            Vue.set(list, index, Object.assign({}, item));
        },
        remove(list, item) {
            var index = this.getIndexByID(list, item.id);
            Vue.delete(list, index);
        },
    },

    watch: {
        selectedVenue: function(id) {
            if (id !== null) {
                this.fetchStages(id);
            }
        },
        selectedStage: function(id) {
            if (id !== null) {
                this.fetchSections(id);
            }
        },
        selectedSection: function(id) {
            if (id !== null) {
                this.fetchSeats(id);
            }
        },
    },

    components: {
        CreateVenue,
    	CreateStage,
        CreateSection,
        CreateSeat,

        VenuesTable,
        VenueModal,
        StagesTable,
        SectionsTable,
        SeatsTable,
    }
}
</script>
